/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import * as PropTypes from 'prop-types';
import {connect} from "react-redux";
import {ShowHide} from "../../atoms/layout/ShowHide";
import {getHomepage} from "../../../selectors/generic";
import {ProductCardIcon} from "../../atoms/ProductCardIcon";
import {PlantForwardIcons} from "./PlantForwardIcons";


class HealthWellbeingIcons extends React.Component {

    static propTypes = {
        tags: PropTypes.array
    };

    static defaultProps = {
        tags: []
    };

    getIcon = (icon) => icon[1];

    getLabel = (icon) => {
        let index = this.props.tags.findIndex(tag => tag.path === icon[0]);
        return (index > -1) ? this.props.tags[index].title : undefined;
    };

    render() {
        const {healthWellbeingConfig, tags, className} = this.props;

        if (!healthWellbeingConfig || !healthWellbeingConfig.enableHealthWellbeing || !healthWellbeingConfig.labelMapping) {
            return null;
        }

        const icons = Object.entries(healthWellbeingConfig.labelMapping)
            .filter(([key]) => tags.findIndex(tag => tag.path === key) > -1)
            .slice(0,2);

        return <div className={"card-icon " + className}>
            <ShowHide show={icons.length}>
                {icons && icons.map(icon => <ProductCardIcon icon={this.getIcon(icon)} label={this.getLabel(icon)}/>)}
                <PlantForwardIcons tags={tags} combineHealthWellbeing={true} amountOfHealthWellbeing={icons.length}/>
            </ShowHide>
            <ShowHide show={icons.length === 0}>
                <PlantForwardIcons tags={tags} combineHealthWellbeing={true} amountOfHealthWellbeing={icons.length}/>
            </ShowHide>
        </div>;
    }

}

const mapStateToProps = (state) => ({
    healthWellbeingConfig: getHomepage(state).healthWellbeingConfiguration,
});

const mapActionsToProps = {
};

export default connect(mapStateToProps, mapActionsToProps)(HealthWellbeingIcons);
